export const FETCH_CUSTOM_SCENARIOS_PENDING = 'action/FETCH_CUSTOM_SCENARIOS_PENDING';
export const FETCH_CUSTOM_SCENARIOS_SUCCESS = 'action/FETCH_CUSTOM_SCENARIOS_SUCCESS';
export const FETCH_CUSTOM_SCENARIOS_FAILURE = 'action/FETCH_CUSTOM_SCENARIOS_FAILURE';

export default {
  FETCH_CUSTOM_SCENARIOS_PENDING,
  FETCH_CUSTOM_SCENARIOS_SUCCESS,
  FETCH_CUSTOM_SCENARIOS_FAILURE,
};
